import { getToken, handleResponse, API } from './utils';

const Public = {
  getHSPPIdOfPatient: async (patient_id) => {
    const token = await getToken();
    let response = null;
    try {
      response = await API.get('/v1/public/get-patient-hspp-id?patient_id=' + patient_id, {
        params: {},
        headers: { Authorization: 'Bearer: ' + token }
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  fetchSubscriptionDetailsByCustomer: async (subscription_id) => {
    const token = await getToken();
    let response = null;
    try {
      response = await API.get(
        `/v1/public/fetch-subscription-details-by-customer/${subscription_id}`,
        {
          headers: { Authorization: 'Bearer: ' + token }
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  cancelSubscriptionByCustomer: async (subscription_id) => {
    const token = await getToken();
    let response = null;
    try {
      response = await API.get(`/v1/public/cancel-subscription-by-customer/${subscription_id}`, {
        headers: { Authorization: 'Bearer: ' + token }
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  createPaymentIntentForVegasConferenceSponsors: async (data) => {
    // const token = await getToken();
    let response = null;
    try {
      response = await API.post(
        `/v1/public/create-payment-intent-for-vegas-conference-sposnors`,
        data,
        {
          // headers: { Authorization: 'Bearer: ' + token }
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  createPaymentIntentForVegasConferenceFranchise: async (data) => {
    // const token = await getToken();
    let response = null;
    try {
      response = await API.post(
        `/v1/public/create-payment-intent-for-vegas-conference-franchise`,
        data,
        {
          // headers: { Authorization: 'Bearer: ' + token }
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  }
};

export default Public;
